import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import clsx from 'clsx';
import styles from '../AIControlRoomAdaptive.module.css';

const IntelCard = ({ card, className, isFaded, isExpanded }) => {
  if (!card) return null;

  const Icon = card.icon;

  return (
    <div
  className={clsx(
    styles.intelCard,
    'h-full',
    className,
    isFaded && styles.faded
  )}
  style={{ '--card-color': card.color }}
>
      <div className={styles.cardHeader}>
        <div
          className={styles.cardLabel}
          style={{
            fontSize: isExpanded ? '14px' : '12px',
            color: isExpanded ? '#1E293B' : '#6B7280',
            fontWeight: isExpanded ? '700' : '600'
          }}
        >
          {card.label}
        </div>
        {Icon && (
          <Icon
            className={styles.cardIcon}
            size={20}
            style={{ color: card.color }}
          />
        )}
      </div>

      <AnimatePresence mode="wait">
        <motion.div
          key={card.value}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          className={styles.cardValue}
          style={{
            fontSize: isExpanded ? '64px' : '36px',
            marginBottom: isExpanded ? '16px' : '8px'
          }}
        >
          {card.value}
        </motion.div>
      </AnimatePresence>

<div
  className={styles.cardContext}
  style={{
    fontSize: isExpanded ? '16px' : '13px',
    lineHeight: isExpanded ? '1.6' : '1.4',
    flex: 'none'
  }}
>
        {card.context}
      </div>

      <motion.div
        className={clsx(
          styles.cardTrend,
          card.trendUp ? styles.trendPositive : styles.trendNegative
        )}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.2 }}
        style={{
          fontSize: isExpanded ? '14px' : '12px',
          // No previous period to compare with: neutral grey, not the green of a good result.
          ...(card.noBaseline ? { background: '#F3F4F6', color: '#6B7280' } : {})
        }}
      >
        <span>{card.trendSign === undefined ? (card.trendUp ? '↑' : '↓') : card.trendSign > 0 ? '↑' : card.trendSign < 0 ? '↓' : '→'}</span>
        <span>{card.trend}</span>
      </motion.div>

<div
  style={{
    display: 'flex',
    alignItems: 'flex-end',
    gap: '3px',
    height: '40px',
    minHeight: 0,
    marginTop: 'auto',
    paddingTop: '8px',
    flexShrink: 1,
    overflow: 'visible',
    position: 'relative'
  }}
>
  {card.chartData?.map((height, i) => (
    <motion.div
      key={i}
      style={{
        flex: 1,
        background: card.color,
        borderRadius: '2px 2px 0 0',
        minWidth: '4px',
        flexShrink: 0
      }}
      initial={{ height: '20%', opacity: 0.3 }}
      animate={{
        height: `${Math.max(20, height)}%`,
        opacity: [0.3, 0.5, 0.3]
      }}
      transition={{
        height: {
          duration: 0.5,
          delay: i * 0.05,
          ease: 'easeOut'
        },
        opacity: {
          duration: 2,
          delay: i * 0.1,
          repeat: Infinity,
          ease: 'easeInOut'
        }
      }}
    />
  ))}
</div>
    </div>
  );
};

export default IntelCard;
